<template>
  <div>
    <v-form ref="DispocicionForm">
      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="¿Dispocición para validador?"
            v-model="form.disposicion.validador"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :items="validador"
            :readonly="readOnly"
            :rules="required"
            item-text="label"
            item-value="value"
            :disabled="dispocicionId !== null"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <v-autocomplete
            v-if="form.disposicion.validador === 0"
            label="Campaña"
            :rules="required"
            v-model="form.campania.campania_id"
            :items="campanias"
            item-text="producto"
            item-value="id"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
            @input="sanitizeSelection"
            :disabled="dispocicionId !== null"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete
            label="Tipo de contacto"
            v-model="form.disposicion.tipo_contacto"
            primary
            color="#00a7e4"
            type="text"
            outlined
            :items="TipoContacto"
            :rules="required"
            item-text="value"
            item-value="value"
            :disabled="dispocicionId !== null"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" md="4">
          <v-combobox
            :key="dispocicionKey"
            label="Nombre de la Disposición"
            v-model="form.disposicion.disposicion"
            :items="distictDispociciones"
            item-text="disposicion.disposicion"
            item-value="disposicion.disposicion"
            :rules="required"
            outlined
            :readonly="readOnly"
            color="#00a7e4"
            :return-object="false"
            :search-input.sync="searchInput"
            @update:search-input="limpiarEntradas"
            :disabled="dispocicionId !== null"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Tiempo de remarcación (en minutos 60 = 1 hora)"
            v-model="form.campania.tiempo_remarcacion"
            outlined
            primary
            type="number"
            :readonly="readOnly"
            color="#00a7e4"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            label="Estatus Lead"
            type="number"
            v-model="form.campania.status_lead"
            :items="
              form.disposicion.validador === 0
                ? EstatusDvalidadorAc
                : EstatusDvalidadorDes
            "
            item-text="value"
            item-value="value"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
            :rules="required"
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            v-if="dispocicionId !== null"
            label="Estatus Disposición"
            type="number"
            v-model="form.campania.status"
            :items="status"
            item-text="label"
            item-value="value"
            outlined
            primary
            :readonly="readOnly"
            color="#00a7e4"
            :rules="required"
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mainAxios } from "@/mainAxios.js";

export default {
  components: {},
  data: () => {
    return {
      required: [
        (value) =>
          (value !== null && value !== undefined && value !== "") ||
          "Campo Requerido",
      ],
      form: {
        disposicion: {
          disposicion: null,
          id: null,
          tipo_contacto: null,
          validador: null,
        },
        campania: {
          campania_disposicion_id: null,
          campania_id: null,
          disposicion_id: null,
          orden: null,
          status: 1,
          status_lead: null,
          tiempo_remarcacion: 0,
          id: null,
        },
      },
      canaleslist: [],
      ramoslist: [],
      plantillasECIList: [],
      campanias: [],
      correosList: [],
      status: [
        { label: "Activo", value: 1 },
        { label: "Inactivo", value: 2 },
      ],
      validador: [
        { label: "Si", value: 1 },
        { label: "No", value: 0 },
      ],
      TipoContacto: [
        { value: "Contacto Efectivo" },
        { value: "Contacto No Efectivo" },
      ],

      EstatusDvalidadorDes: [
        { value: "Agenda" },
        { value: "Pago" },
        { value: "Emisión" },
        { value: "Seguimiento Validación pago" },
        { value: "Finalizado" },
      ],
      EstatusDvalidadorAc: [
        { value: "Agenda" },
        { value: "Seguimiento" },
        { value: "Finalizado" },
      ],

      estatus_marcacion: [{ value: "Seguimiento" }, { value: "Finalizado" }],
      empresaslist: [],
      agentesList: [],
      aseguradorasList: [],
      distictDispociciones: [],
      dispocicionKey: 0,
      searchInput: null,
    };
  },
  props: {
    toSave: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    dispocicionId: {
      type: Number,
      default: null,
    },
    dispocicionesData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    toSave(val) {
      if (!val) return;
      if (val) {
        const isValid = this.$refs.DispocicionForm.validate();
        if (isValid) {
          this.$emit("goTosave", isValid, { ...this.form });
        } else {
          this.$emit("update:toSave", false);
        }
      }
    },
    searchInput(val) {
      if (val !== null) this.form.disposicion.disposicion = val;
    },
    "form.disposicion.disposicion"(newValue, oldValue) {
      console.log("Nombre de la Disposición changed:", { oldValue, newValue });
    },

    dispocicionesData: {
      immediate: true,
      handler(newVal) {
        if (!newVal || !Object.keys(newVal).length) return;

        Object.keys(newVal).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(this.form, key)) {
            this.form[key] = newVal[key];
          }
        });
        this.dispocicionKey += 1;
      },
    },

    "form.campania.campania_id"(newValue) {
      if (newValue !== null) {
        console.log(newValue);
        this.getDisopocicionesDistinct();
      }
    },
  },
  computed: {},
  mounted() {
    this.getCampanias();
  },
  methods: {
    limpiarEntradas(val) {
      if (!val) return;

      let cleaned = this.removeAccentsAndSpecialChars(val);
      cleaned =
        cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();

      if (val !== cleaned) {
        this.$nextTick(() => {
          this.searchInput = cleaned;
        });
      }
    },
    removeAccentsAndSpecialChars(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/[^a-zA-Z\s|]/g, ""); // remove special chars
    },

    getCampanias() {
      this.loading = true;

      mainAxios
        .post(
          "/v1/campania/filters",
          //  { area_negocio_id: localStorage.area_negocio_id, },
          { area_negocio_id: [1] },
          {
            headers: {
              Authorization: `Bearer ${localStorage.agenteAccessToken}`,
            },
          }
        )
        .then((res) => {
          this.totalItems = res.data.count;
          this.campanias = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.campanias = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDisopocicionesDistinct() {
      this.loading = true;
      mainAxios
        .post(
          "/v1/disposiciones_outbound/filter",
          { campania_id: this.form.campania.campania_id },
          {
            headers: {
              Authorization: `Bearer ${localStorage.agenteAccessToken}`,
            },
          }
        )
        .then((res) => {
          this.totalItems = res.data.count;
          this.distictDispociciones = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.distictDispociciones = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.v-application p {
  margin-bottom: 0px !important;
}
</style>
